<template>
  <v-container fluid>
    <PageHeaderSlot />

    <v-form ref="dataForm" @submit.prevent="">
      <v-card class="mb-4">
        <v-card-text class="px-2">
          <v-row class="ma-0">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormSelect
                label="redeemFunction"
                :fieldValue.sync="formData.points_enable"
                dispatchUpdateOnChange
                :options="statusOptions"
                required
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>
          <v-row class="ma-0" v-if="formData.points_enable === true">
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="pointValidDay"
                :fieldValue.sync="formData.points_expiry_days"
                isIntegerOnly
                dispatchUpdateOnChange
                :required="formData.points_enable === true"
                suffix="day"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="pointsPerLesson"
                :fieldValue.sync="formData.points_per_lesson"
                isIntegerOnly
                dispatchUpdateOnChange
                :required="formData.points_enable === true"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="welcomePoints"
                :fieldValue.sync="formData.points_welcome"
                isIntegerOnly
                dispatchUpdateOnChange
                :hint="welcomeHint"
                :readonly="!canEdit"
              />
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
              <FormInput
                type="number"
                label="studentPerfectAttendanceReward"
                :fieldValue.sync="formData.points_full_attend"
                isIntegerOnly
                dispatchUpdateOnChange
                hint="studentPerfectAttendanceRewardDes"
                :readonly="!canEdit"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <div class="d-flex align-center mt-4" v-if="canEdit">
        <FormButton @click="save()" />
      </div>
    </v-form>
  </v-container>
</template>

<script>
import FormInput from '@/components/formField/FormInput.vue'
import FormSelect from '@/components/formField/FormSelect.vue'

export default {
  name: 'PointsSetting',
  components: {
    FormInput,
    FormSelect,
  },
  computed: {
    welcomeHint() {
      let point = 0
      if (this.$validate.DataValid(this.formData.points_welcome) && !isNaN(parseInt(this.formData.points_welcome))) {
        point = this.formData.points_welcome
      }
      return this.$t('welcomePointsDes', { points: point })
    },
    canEdit() {
      // [T46] admin account 只可read
      return !this.isAppMode(['T46']) || this.userType !== 'admin'
    },
  },
  data: vm => ({
    userType: vm.gfGetUserType(),
    formData: {
      points_enable: false,
      points_per_lesson: 0,
      points_expiry_days: '',
      points_welcome: 0,
      points_full_attend: 0,
    },
    statusOptions: [
      { value: true, text: vm.$t('active') },
      { value: false, text: vm.$t('inactive') },
    ],
  }),
  methods: {
    async getSetting() {
      try {
        const data = await this.$Fetcher.GetSetting()
        for (const key in this.formData) {
          if (this.$validate.DataValid(data[key])) {
            this.formData[key] = data[key]
          }
        }
      } catch (err) {
        this.$common.error(err)
      } finally {
        this.$store.dispatch('toggleLoadingPage', false)
        this.tableLoading = false
      }
    },

    async save() {
      if (this.$store.getters.isLoading) {
        this.$store.dispatch('toggleSnack', { message: 'processing' })
        return
      }

      if (!this.canEdit) {
        this.$store.dispatch('toggleSnack', { message: 'noPermission' })
        return
      }

      const valid = this.$refs['dataForm'].validate()
      if (!valid) {
        this.$store.dispatch('toggleSnack', { message: 'required' })
        return
      }
      this.$store.dispatch('setLoading', true)
      let payload = {
        points_enable: this.formData.points_enable || false,
        points_per_lesson: 0,
        points_expiry_days: 0,
        points_welcome: 0,
        points_full_attend: 0,
      }

      if (this.formData.points_enable) {
        if (this.$validate.DataValid(this.formData.points_per_lesson)) {
          payload['points_per_lesson'] = parseInt(this.formData.points_per_lesson)
        }

        if (this.$validate.DataValid(this.formData.points_expiry_days)) {
          payload['points_expiry_days'] = parseInt(this.formData.points_expiry_days)
        }
        if (this.$validate.DataValid(this.formData.points_welcome)) {
          payload['points_welcome'] = parseInt(this.formData.points_welcome)
        }

        if (this.$validate.DataValid(this.formData.points_full_attend)) {
          payload['points_full_attend'] = parseInt(this.formData.points_full_attend)
        }
      }

      try {
        await this.$Fetcher.UpdateSetting(payload)
        this.$store.dispatch('setDataIsUpdated', false)
        this.$store.dispatch('toggleSnack', {
          message: 'message.saveSuccess',
          type: 'success',
          refresh: true,
        })
      } catch (err) {
        this.$common.error(err)
        this.showAlert({
          title: 'message.saveFail',
          message: err,
          isError: true,
        })
      } finally {
        this.$store.dispatch('setLoading', false)
      }
    },

    async handleSiteLoaded() {
      this.$common.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>> handleSiteLoaded: PointsSetting')
      this.userType = this.gfGetUserType()
      this.getSetting()
    },
  },

  destroyed() {
    window.removeEventListener('onSiteLoaded', this.handleSiteLoaded)
  },
  mounted() {
    this.$store.dispatch('toggleLoadingPage', true)
    window.addEventListener('onSiteLoaded', this.handleSiteLoaded)
  },

  // ------ navigation guard ------
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.isLoading) {
      this.$store.dispatch('toggleSnack', { message: 'processing' })
      next(false)
    } else if (this.$store.getters.dataIsUpdated) {
      this.$store.dispatch('showLeaveAlert', { toLink: { name: to.name } })
      next(false)
    } else {
      next()
    }
  },
}
</script>
